<template>
  <div>
    <p class="cm-mg-p-wzd text-center text-muted">
      {{ $t('common_words.farm_administrative') }}
    </p>
    <hr />
    <div class="row" v-for="index in model.nManagementRoles" :key="index">
      <div class="col-6">
        <label>{{ $t('common_words.administrative_role') }}: </label>
        <br />
        <el-select
          clearable
          filterable
          collapse-tags
          class="select-primary custom-width-select shadow-sm mb-4 required-mgmt-roles"
          size="large"
          v-model.trim="model.mgmt_roles[index - 1]"
          :placeholder="`${$t('common_words.select')}...`"
        >
          <el-option
            v-for="option in availableMgmtRoles"
            class="select-primary"
            :value="option.id"
            :label="option.name"
            :key="option.id"
          ></el-option>
        </el-select>
      </div>
      <div class="col-4">
        <label>{{ $t('common_words.associated_users2') }}: </label>
        <br />
        <el-select
          clearable
          filterable
          multiple
          collapse-tags
          class="select-primary custom-width-select shadow-sm required-mgmt-users"
          size="large"
          v-model.trim="model.mgmt_users[index - 1]"
          :placeholder="`${$t('common_words.select')}...`"
          @change="
            selectAllFromSelectLots(
              $event,
              `model.mgmt_users[${index - 1}]`,
              users
            )
          "
        >
          <el-option
            v-for="option in users"
            class="select-primary selected-all"
            :value="option.id"
            :label="option.name"
            :key="option.id"
          ></el-option>
        </el-select>
      </div>
      <div class="col-1">
        <div class="text-left">
          <label style="color: transparent">{{
            $t('common_words.options')
          }}</label>
          <button
            class="btn btn-secondary custom-shadow-btn"
            @click="handlePlus(index - 1)"
          >
            <em class="fa fa-plus"></em>
          </button>
        </div>
      </div>
      <div class="col-1">
        <div class="text-left">
          <label style="color: transparent">{{
            $t('common_words.options')
          }}</label>
          <button
            class="btn btn-secondary custom-shadow-btn"
            @click="handleMinus(index - 1)"
          >
            <em class="fa fa-minus"></em>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

export default {
  data() {
    return {
      users: null,
      managementRoles: null,
      model: {
        nManagementRoles: 1,
        mgmt_roles: [],
        mgmt_users: [],
      },
    };
  },

  mixins: [MixinPermissions, mixinMasters],

  computed: {
    availableMgmtRoles() {
      if (this.managementRoles) {
        return this.managementRoles.filter(
          (role) =>
            !this.model.mgmt_roles.some(
              (selectedRole) => selectedRole === role.id
            )
        );
      }
    },
  },

  methods: {
    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', {
            ...this.model,
            mgmtRolesSelected: this.model.mgmt_roles
              ? this.getNameSelected(
                  this.model.mgmt_roles,
                  this.managementRoles
                )
              : null,
            mgmtRolesUsersSelected: this.model.mgmt_users
              ? this.getAllMgmtUserSelected(this.model.mgmt_users, this.users)
              : null,
          });
        })
        .then(() => {
          if (!isset(this.model.mgmt_roles)) {
            return this.validationInputsRequired('mgmt-roles');
          } else if (!isset(this.model.mgmt_users[0])) {
            return this.validationInputsRequired('mgmt-users');
          } else return true;
        });
    },

    handleChangeSelected(data) {
      this.$set(this.model, data.name, data.selects);
    },

    handleMinus(indexM) {
      if (this.model.nManagementRoles > 1) {
        this.model.mgmt_roles.splice(indexM, 1);
        this.model.mgmt_users.splice(indexM, 1);
        this.model.nManagementRoles--;
      }
    },

    handlePlus() {
      if (this.model.nManagementRoles < this.managementRoles.length) {
        this.model.nManagementRoles++;
      }
    },

    getAllMgmtUserSelected(model, origin) {
      const res = model
        .slice(0, this.model.nManagementRoles)
        .map((selectedModel, index) => {
          return this.getNameSelected(selectedModel, origin);
        });

      return res;
    },

    handleEditForm(editForm) {
      let management_roles = editForm.management_roles;
      if (management_roles.length > 0) {
        management_roles.forEach((element) => {
          const indice = this.managementRoles.findIndex(
            (value) => value.id === element.id
          );

          if (!this.model.mgmt_roles.includes(element.id)) {
            this.model.mgmt_roles.push(element.id);

            // Convertir el objeto de usuarios en un array de IDs
            const userIds = Object.keys(element.users).map((userId) =>
              parseInt(userId)
            );
            this.$set(this.model.mgmt_users, indice, userIds);
          } else {
            // Si ya existe el rol, concatenar los IDs de usuarios
            const userIds = Object.keys(element.users).map((userId) =>
              parseInt(userId)
            );
            this.model.mgmt_users[indice].push(...userIds);
          }
        });

        this.model.nManagementRoles = this.model.mgmt_roles.length;
      }
    },
  },

  created() {
    this.showHideLoading(true);
    Promise.all([
      Axios.getMasters('users/indexfield'),
      Axios.getMasters('managementroles'),
    ])
      .then(([usersResponse, farmsMgmtRolesResponse]) => {
        this.users = this.concatAll(usersResponse.data.data);
        this.managementRoles = farmsMgmtRolesResponse.data.data;

        if (this.isUpdate() && sessionStorage.getItem('editForm')) {
          this.handleEditForm(JSON.parse(sessionStorage.getItem('editForm')));
        }

        this.showHideLoading();
      })
      .catch((error) => {
        this.showHideLoading();
        SweetAlert.warning(error.response.data.message);
      });
  },
};
</script>
